import React, { lazy, Suspense } from 'react';

import { Loader } from '../common/components/Loader';
import { ChatbotProps } from './types';

const LazyChatbot = lazy(() => {
  return import('./Chatbot' /* webpackChunkName: "Chatbot" */).then((i) => ({
    default: i.Chatbot,
  }));
});

export const Chatbot = (props: ChatbotProps) => (
  <Suspense
    fallback={
      <Loader
        height="100%"
        verticalAlign="middle"
        width="100%"
        backgroundColor="#F0F4F7"
      />
    }
  >
    <LazyChatbot {...props} />
  </Suspense>
);
